import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificateButtonExpired = ({
  description,
  expiresAt,
  isSelected,
  name,
  onClick
}) => {
  return /*#__PURE__*/_jsx(SelectableBox, {
    inlineSize: "max-content",
    marginBlockEnd: "400",
    minInlineSize: "248px",
    onClick: onClick,
    padding: "100",
    paddingInline: "400",
    selected: isSelected,
    type: "default",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "end",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: description,
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          inlineSize: "100%",
          paddingInlineEnd: "400",
          children: [name, /*#__PURE__*/_jsx(Small, {
            use: "help",
            weight: "regular",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "learningCenter.mostPopularCertificates.expired",
              options: {
                date: /*#__PURE__*/_jsx(FormattedDateTime, {
                  format: "L",
                  value: expiresAt
                })
              }
            })
          })]
        })
      }), /*#__PURE__*/_jsx(View, {
        blockSize: "60%",
        borderInlineStartColor: "border-interactive-default",
        borderInlineStartStyle: "solid",
        borderInlineStartWidth: "100",
        marginInlineStart: "250",
        paddingInlineStart: "250",
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "learningCenter.mostPopularCertificates.expiredTooltip",
            options: {
              date: /*#__PURE__*/_jsx(FormattedDateTime, {
                format: "L",
                value: expiresAt
              })
            }
          }),
          children: /*#__PURE__*/_jsx(InfoIcon, {
            color: "icon-core-default",
            size: "300"
          })
        })
      })]
    })
  });
};
export default CertificateButtonExpired;